import React, { useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Monogram from "./Monogram";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/traditional", label: "Traditional Wedding" },
  { to: "/registry", label: "Registry" },
  { to: "/rsvp", label: "RSVP" },
  { to: "/contact", label: "Contact" },
];

const Layout = ({ children }) => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <div className="min-h-screen relative grain">
      <header
        data-testid="site-header"
        className="sticky top-0 z-40 backdrop-blur-xl bg-[#FBF7F1]/85 border-b border-[#B08D57]/20"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="nav-home-logo">
            <Monogram className="h-8 w-8" />
            <div className="leading-tight">
              <div className="font-serif text-[17px] tracking-tight text-ink">Anjola &amp; Michael</div>
              <div className="text-[9px] tracking-[0.35em] uppercase text-gold">With Love · 05 · 08 · 2027</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `nav-link text-[13px] tracking-wide text-ink-soft hover:text-ink`
                }
              >
                {({ isActive }) => (
                  <span data-active={isActive ? "true" : "false"} className="nav-link inline-block">
                    {n.label}
                  </span>
                )}
              </NavLink>
            ))}
          </nav>

          <Link
            to="/rsvp"
            data-testid="nav-rsvp-cta"
            className="hidden lg:inline-flex btn-gold border border-gold text-gold text-[11px] tracking-[0.25em] uppercase px-5 py-2.5 rounded-full"
          >
            RSVP
          </Link>

          <button
            data-testid="nav-menu-toggle"
            className="lg:hidden p-2 text-ink"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden border-t border-[#B08D57]/20 bg-[#FBF7F1]" data-testid="mobile-nav">
            <div className="px-6 py-4 flex flex-col gap-3">
              {NAV.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.to === "/"}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-ink-soft py-2 border-b border-hairline"
                >
                  {n.label}
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </header>

      <main key={loc.pathname} className="relative z-[2] animate-fade-up">{children}</main>

      <footer className="relative z-[2] mt-24 border-t border-hairline bg-ivory">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-3 gap-10">
          <div>
            <Monogram className="h-16 w-auto" />
            <p className="mt-4 text-sm text-ink-soft leading-relaxed max-w-xs">
              Two hearts. Two families. One beautiful celebration.
            </p>
          </div>
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-gold mb-3">Explore</div>
            <ul className="space-y-2 text-sm text-ink-soft">
              {NAV.map((n) => (
                <li key={n.to}><Link to={n.to} className="nav-link inline-block">{n.label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-gold mb-3">Save the Date</div>
            <div className="font-serif text-3xl text-ink leading-none">May 8, 2027</div>
            <div className="mt-2 text-sm text-ink-soft">Balmoral · Traditional Ceremony</div>
            <div className="mt-6 text-[10px] tracking-[0.3em] uppercase text-ink-faint">
              © {new Date().getFullYear()} The Temowo & Itemuagbor Families
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
;
